export const STATUS_OPTIONS = ["new", "contacted", "consulta", "scheduled", "archived_done", "archived_cancelled", "no_book"];

export const STATUS_LABELS = {
  new: "New",
  contacted: "Contacted",
  consulta: "Consulta",
  scheduled: "Booked",
  archived_done: "Done",
  archived_cancelled: "Closed",
  no_book: "No Book",
  archived: "Done",
};

// Notebook-inspired ink colours: red for booked/consult, black for done, grey for closed.
export const STATUS_TONE = {
  new: "bg-white text-[#0A0A0A] border-[#0A0A0A]",
  contacted: "bg-[#F5F5F5] text-[#0A0A0A] border-[#CFCFCF]",
  consulta: "bg-[#FFF4F4] text-[#B3261E] border-[#B3261E]",
  scheduled: "bg-[#B3261E] text-white border-[#B3261E]",
  archived_done: "bg-[#0A0A0A] text-white border-[#0A0A0A]",
  archived: "bg-[#0A0A0A] text-white border-[#0A0A0A]",
  archived_cancelled: "bg-white text-[#999] border-[#DDD] line-through",
  no_book: "bg-white text-[#666] border-[#BBB]",
};

export const shortDate = (d) => {
  if (!d) return "";
  const [y, m, day] = d.split("-");
  return `${parseInt(day, 10)}/${parseInt(m, 10)}`;
};
